var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandlord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#EFE8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#EFE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_8984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38892 13.3333V19.9999C8.38892 21.0475 8.38892 21.5713 8.71435 21.8967C9.03979 22.2221 9.56357 22.2221 10.6111 22.2221H18.3889C19.4365 22.2221 19.9603 22.2221 20.2857 21.8967C20.6111 21.5713 20.6111 21.0475 20.6111 19.9999V13.3333",
    stroke: "#7F43FF",
    strokeWidth: 1.11111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27783 14.4444L12.9287 8.79351C13.6694 8.05278 14.0398 7.68241 14.5001 7.68241C14.9603 7.68241 15.3307 8.05278 16.0714 8.79352L21.7223 14.4444",
    stroke: "#7F43FF",
    strokeWidth: 1.11111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2778 19.4444C12.2778 18.3968 12.2778 17.873 12.6033 17.5476C12.6033 17.5476 12.6033 17.5476 12.6033 17.5476C12.9287 17.2222 13.4525 17.2222 14.5001 17.2222C15.5476 17.2222 16.0714 17.2222 16.3968 17.5476C16.3968 17.5476 16.3968 17.5476 16.3968 17.5476C16.7223 17.873 16.7223 18.3968 16.7223 19.4444V22.7777H12.2778V19.4444Z",
    fill: "#7F43FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 9.44436C17.8334 8.92058 17.8334 8.65869 17.9961 8.49597C17.9961 8.49597 17.9961 8.49597 17.9961 8.49597C18.1588 8.33325 18.4207 8.33325 18.9445 8.33325C19.4683 8.33325 19.7302 8.33325 19.8929 8.49597C19.8929 8.49597 19.8929 8.49597 19.8929 8.49597C20.0556 8.65869 20.0556 8.92058 20.0556 9.44436V12.7777L18.4842 11.2063C18.1631 10.8852 18.0025 10.7246 17.918 10.5204C17.8334 10.3163 17.8334 10.0892 17.8334 9.635V9.44436Z",
    fill: "#7F43FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_8984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(4.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlord);
export default __webpack_public_path__ + "static/media/landlord.c2119c0f7bcea196f0a1c3f228dbac04.svg";
export { ForwardRef as ReactComponent };